export default "__VITE_ASSET__BggAb0zo__"